import { useState } from 'react';
import cx from 'classnames';

import styles from './Card.module.less';
import { Back, Front } from './components';

const Card = (props) => {
  const [opened, setOpened] = useState(false);
  const {
    background,
    size = 'md',
    item,
    hideDescription = false,
    hideIcons = false,
    columns = '4',
    isEditMode,
    primary = false,
    serviceCard = false,
  } = props;
  const {
    title,
    subtitle,
    description,
    titulo_card,
    descricao_card,
    review_state,
  } = item;

  const cardTitle = titulo_card || title;
  const cardDescription = hideDescription
    ? null
    : descricao_card || description;

  const flipCard = (e) => {
    e.preventDefault();
    setOpened(!opened);
  };

  const classes = cx(
    {
      [styles.opened]: opened,
      [styles.card]: !opened,
      [`review-state-${review_state}`]:
        review_state && review_state !== 'published',
    },
    styles[size],
    styles[background],
    'custom-card',
  );

  return (
    <div className={classes}>
      <Front
        title={cardTitle}
        subtitle={subtitle}
        description={cardDescription}
        hideIcons={hideIcons}
        size={size}
        item={item}
        background={background}
        opened={opened}
        handleFlip={flipCard}
        columns={columns}
        isEditMode={isEditMode}
        primary={primary}
        serviceCard={serviceCard}
      />
      {cardDescription ? (
        <Back
          title={cardTitle}
          description={cardDescription}
          item={item}
          opened={opened}
          handleFlip={flipCard}
          size={size}
          columns={columns}
          isEditMode={isEditMode}
        />
      ) : null}
    </div>
  );
};

export default Card;
